import React, { Fragment } from "react";

import { Dashboard } from "./dashboard";
import { Container } from "./styles";

export const MasterDashboard: React.FC = () => {
  return (
    <Fragment>
      <Container>
        <Dashboard />
      </Container>
    </Fragment>
  );
};
